/**
 * The CUI banner marking, fixed to the top and bottom of every page, in a build
 * made with VITE_CUI_BANNER=true (the enclave's: .gitlab-ci.yml build:frontend).
 * main.tsx puts `cui-banner` on <html>, and each bar publishes its height as
 * --cui-banner-top / --cui-banner-bottom (the top one wraps on a narrow
 * window): the body is padded by them, h-screen and min-h-screen are the window
 * less both (--app-height, index.css), and full-window overlays sit between.
 */
import { useLayoutEffect, useRef } from 'react'

export const CUI_BANNER = import.meta.env.VITE_CUI_BANNER === 'true'

// White on green. No NARA or DoD rule sets a banner color.
const bar = 'fixed inset-x-0 z-[9999] bg-[#2f7d31] px-4 py-0.5 text-center text-xs font-medium text-white'

export default function CuiBanner() {
  const top = useRef<HTMLDivElement>(null)
  const bottom = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (!CUI_BANNER) return
    const root = document.documentElement.style
    const observer = new ResizeObserver(() => {
      root.setProperty('--cui-banner-top', `${top.current!.offsetHeight}px`)
      root.setProperty('--cui-banner-bottom', `${bottom.current!.offsetHeight}px`)
    })
    observer.observe(top.current!)
    observer.observe(bottom.current!)
    return () => observer.disconnect()
  }, [])

  if (!CUI_BANNER) return null
  return (
    <>
      <div ref={top} className={`${bar} top-0`}>
        NOTICE: This system processes Controlled Unclassified Information (CUI). Use is restricted to authorized
        users. All activity is monitored and recorded. Unauthorized use may result in disciplinary action or
        criminal prosecution.
      </div>
      <div ref={bottom} className={`${bar} bottom-0`}>CUI System - All activities are monitored</div>
    </>
  )
}
